import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { dateCompare } from "jsFunctions/dateTimeFormat";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import { useMemo } from "react";

const ReimbursementAmountTable = ({
  editReimbursementInfo,
  currentReimbursementInfo,
  type,
}) => {
  const editReimbursementData = useMemo(() => {
    if (editReimbursementInfo) {
      const remb = editReimbursementInfo?.rmbInfo;
      return [
        {
          invoiceDate: remb?.inDt || Date.now(),
          invoiceNumber: remb?.inNo,
          isReimburs: remb?.isRmb?.sts ? "true" : "false",
          amount: Number(remb?.isRmb?.amt || 0),
          amountInINR: Number(remb?.isRmb?.inr || 0),
          conversionRate: remb?.isRmb?.cnvRt,
          paymentDate: remb?.isRmb?.pmtDt,
          currency: remb?.isRmb?.crId,
        },
      ];
    }
    return [];
  }, [editReimbursementInfo]);

  const currentReimbursementData = useMemo(() => {
    if (currentReimbursementInfo) {
      return [
        {
          invoiceDate: currentReimbursementInfo?.invoiceDate,
          invoiceNumber: currentReimbursementInfo?.invoiceNum,
          isReimburs: currentReimbursementInfo?.isReimburs ? "true" : "false",
          amount: Number(currentReimbursementInfo?.reimburseAmount || 0),
          amountInINR: Number(currentReimbursementInfo?.amountInINR || 0),
          conversionRate: currentReimbursementInfo.conversionRate || 0,
          paymentDate: currentReimbursementInfo?.reimbursementPaymentDate,
          currency: currentReimbursementInfo?.currency,
        },
      ];
    }
    return [];
  }, [currentReimbursementInfo]);

  return type === "current" ? (
    <div className="info-table change-modal-table">
      <Table className="table-info">
        <Thead>
          <Tr>
            <Th>Invoice Date</Th>
            <Th>Invoice Number</Th>
            <Th>Amount</Th>
            <Th>Amount In INR</Th>
            <Th>Conversion Rate</Th>
            <Th>Currency</Th>
          </Tr>
        </Thead>
        <Tbody>
          {editReimbursementData?.map((item, index) => {
            return (
              <Tr>
                <Td
                  className={`${
                    !dateCompare(
                      dateTimeFormat(item?.invoiceDate),
                      dateTimeFormat(
                        currentReimbursementData[index]?.invoiceDate
                      )
                    )
                      ? "data_compare_red"
                      : ""
                  }`}
                >
                  {dateTimeFormat(item?.invoiceDate)}
                </Td>
                <Td
                  className={`${
                    item?.invoiceNumber !==
                    currentReimbursementData[index]?.invoiceNumber
                      ? "data_compare_red"
                      : ""
                  }`}
                >
                  <Box>{item?.invoiceNumber}</Box>
                </Td>

                <Td
                  className={`${
                    item?.amount !== currentReimbursementData[index]?.amount
                      ? "data_compare_red"
                      : ""
                  }`}
                >
                  <Box>{formatAmountInINR(parseFloat(item?.amount || 0))}</Box>
                </Td>
                <Td
                  className={`${
                    item?.amountInINR !==
                    currentReimbursementData[index]?.amountInINR
                      ? "data_compare_red"
                      : ""
                  }`}
                >
                  <Box>
                    {formatAmountInINR(parseFloat(item?.amountInINR || 0))}
                  </Box>
                </Td>
                <Td
                  className={`${
                    Number(item?.conversionRate || 0) !==
                    Number(currentReimbursementData[index]?.conversionRate || 0)
                      ? "data_compare_red"
                      : ""
                  }`}
                >
                  <Box>
                    {formatAmountInINR(parseFloat(item?.conversionRate || 0))}
                  </Box>
                </Td>
                <Td
                  className={`${
                    item?.currency?.val !==
                    currentReimbursementData[index]?.currency
                      ? "data_compare_red"
                      : ""
                  }`}
                >
                  <Box>{item?.currency?.val}</Box>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </div>
  ) : (
    <div className="info-table change-modal-table">
      <Table className="table-info">
        <Thead>
          <Tr>
            <Th>Invoice Date</Th>
            <Th>Invoice Number</Th>
            <Th>Amount</Th>
            <Th>Amount In INR</Th>
            <Th>Conversion Rate</Th>
            <Th>Currency</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentReimbursementData?.map((item, index) => {
            return (
              <Tr>
                <Td
                  className={`${
                    !dateCompare(
                      dateTimeFormat(item?.invoiceDate),
                      dateTimeFormat(
                        currentReimbursementData[index]?.invoiceDate
                      )
                    )
                      ? "data_compare_red"
                      : ""
                  }`}
                >
                  {dateTimeFormat(item?.invoiceDate)}
                </Td>
                <Td
                  className={`${
                    item?.invoiceNumber !==
                    editReimbursementData[index]?.invoiceNumber
                      ? "data_compare_green"
                      : ""
                  }`}
                >
                  <Box>{item?.invoiceNumber}</Box>
                </Td>

                <Td
                  className={`${
                    Number(item?.amount || 0) !==
                    Number(editReimbursementData[index]?.amount || 0)
                      ? "data_compare_green"
                      : ""
                  }`}
                >
                  <Box>{formatAmountInINR(parseFloat(item?.amount || 0))}</Box>
                </Td>
                <Td
                  className={`${
                    Number(item?.amountInINR || 0) !==
                    Number(editReimbursementData[index]?.amountInINR || 0)
                      ? "data_compare_green"
                      : ""
                  }`}
                >
                  <Box>
                    {formatAmountInINR(parseFloat(item?.amountInINR || 0))}
                  </Box>
                </Td>
                <Td
                  className={`${
                    Number(item?.conversionRate || 0) !==
                    Number(editReimbursementData[index]?.conversionRate || 0)
                      ? "data_compare_green"
                      : ""
                  }`}
                >
                  <Box>
                    {formatAmountInINR(parseFloat(item?.conversionRate || 0))}
                  </Box>
                </Td>
                <Td
                  className={`${
                    item?.currency !==
                    editReimbursementData[index]?.currency?.val
                      ? "data_compare_green"
                      : ""
                  }`}
                >
                  <Box>{item?.currency}</Box>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </div>
  );
};

export default ReimbursementAmountTable;
